import React from 'react';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import styled, { useTheme } from 'styled-components';
import Screens from 'shared/screens';
import { BUTTON_STROKES } from 'shared/utils/buttonTextStrokes';
import generateRender from 'shared/utils/generateRender';
import { buyButtonWithGradient } from 'shared/components/NavigationBar/utils';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { pwaStyleAdapter } from '../../../utils/mobileSupported';
import ImageBW from '../../ImageBoundsWrapper';
import TimeRemainingText from '../../TimeRemainingText';
import Button from '../../Button/Button';

function MiddleSeciton({ IapButtonState, showModal, limitedTimeOffer }) {
  const splitButton = IapButtonState === 2 || IapButtonState === 3;
  const themeContext = useTheme();
  return (
    <MiddleSectionContainer>
      <ImageBW
        style={pwaStyleAdapter(Styles.ButtonWrapperStyle, null, 1.25)}
        source={assetSource(ASSET_KEY.IAP_BACKING)}
        ibw={require(asset`images/top-bar-assets/iap-backing.ibw`)}
        manualAssetScale={3}
        innerStyle={Styles.ButtonWrapperInnerStyle}
      >
        {/* whole button not sale*/}
        <Button
          opacity={IapButtonState === 0 ? 1 : 0}
          display={IapButtonState === 0 ? 'flex' : 'none'}
          gradientLabel={buyButtonWithGradient}
          gradentLabelTextStyle={
            splitButton
              ? themeContext.NavigationBar.BuySaleSplittedTextGradient
              : themeContext.NavigationBar.BuySaleTextGradient
          }
          textStroke={themeContext.NavigationBar.BuyDealTextStroke.color}
          imageSource={noSaleBuyButtonAsset}
          onClick={() => showModal(Screens.Shop)}
          containerStyle={Styles.ButtonContainserStyles}
          imageStyle={Styles.ButtonImageStyles}
          label={getText(TEXT_KEY.BUY)}
          textStyle={{
            paddingLeft: splitButton ? '5%' : 0,
            ...themeContext.NavigationBar.BuyDealText,
            ...(splitButton ? themeContext.NavigationBar.SplittedLeftButton : themeContext.NavigationBar.FullButton),
          }}
        />
        {/* whole button sale */}
        <Button
          opacity={IapButtonState === 1 ? 1 : 0}
          display={IapButtonState === 1 ? 'flex' : 'none'}
          gradientLabel={buyButtonWithGradient}
          gradentLabelTextStyle={
            splitButton
              ? themeContext.NavigationBar.BuySaleSplittedTextGradient
              : themeContext.NavigationBar.BuySaleTextGradient
          }
          textStroke={themeContext.NavigationBar.BuyDealTextStroke.color}
          imageSource={saleBuyButtonAsset}
          onClick={() => showModal(Screens.Shop)}
          containerStyle={Styles.ButtonContainserStyles}
          imageStyle={Styles.ButtonImageStyles}
          label={getText(TEXT_KEY.SALE)}
          textStyle={{
            paddingLeft: splitButton ? '5%' : 0,
            ...themeContext.NavigationBar.BuyDealText,
            ...(splitButton ? themeContext.NavigationBar.SplittedLeftButton : themeContext.NavigationBar.FullButton),
          }}
        />
        {/* split button left no sale */}
        <Button
          opacity={IapButtonState === 2 ? 1 : 0}
          display={IapButtonState === 2 ? 'flex' : 'none'}
          gradientLabel={buyButtonWithGradient}
          gradentLabelTextStyle={
            splitButton
              ? themeContext.NavigationBar.BuySaleSplittedTextGradient
              : themeContext.NavigationBar.BuySaleTextGradient
          }
          textStroke={themeContext.NavigationBar.BuyDealTextStroke.color}
          imageSource={noSaleDealLeftSideButtonAsset}
          onClick={() => showModal(Screens.Shop)}
          containerStyle={Styles.ButtonContainserStyles}
          imageStyle={Styles.ButtonImageStyles}
          label={getText(TEXT_KEY.BUY)}
          textStyle={{
            paddingLeft: splitButton ? '5%' : 0,
            ...themeContext.NavigationBar.BuyDealText,
            ...(splitButton ? themeContext.NavigationBar.SplittedLeftButton : themeContext.NavigationBar.FullButton),
          }}
        />
        {/* split button left sale */}
        <Button
          opacity={IapButtonState === 3 ? 1 : 0}
          display={IapButtonState === 3 ? 'flex' : 'none'}
          gradientLabel={buyButtonWithGradient}
          gradentLabelTextStyle={
            splitButton
              ? themeContext.NavigationBar.BuySaleSplittedTextGradient
              : themeContext.NavigationBar.BuySaleTextGradient
          }
          textStroke={themeContext.NavigationBar.BuyDealTextStroke.color}
          imageSource={saleDealLeftSideButtonAsset}
          onClick={() => showModal(Screens.Shop)}
          containerStyle={Styles.ButtonContainserStyles}
          imageStyle={Styles.ButtonImageStyles}
          label={getText(TEXT_KEY.SALE)}
          textStyle={{
            paddingLeft: splitButton ? '5%' : 0,
            ...themeContext.NavigationBar.BuyDealText,
            ...(splitButton ? themeContext.NavigationBar.SplittedLeftButton : themeContext.NavigationBar.FullButton),
          }}
        />
        {/* right split button */}
        <Button
          gradientLabel={buyButtonWithGradient}
          gradentLabelTextStyle={themeContext.NavigationBar.DealSplittedTextGradient}
          imageSource={saleDealRightSideButtonAsset}
          onClick={() => showModal(Screens.LimitedTimeOffer)}
          opacity={splitButton ? 1 : 0}
          display={splitButton ? 'flex' : 'none'}
          containerStyle={Styles.RightSplitButtonContainerStyle}
          imageStyle={Styles.RightSplitButtonImageStyle}
          label={getText(TEXT_KEY.DEAL)}
          textStyle={themeContext.NavigationBar.SplittedRightButton}
          textStroke={BUTTON_STROKES.PINK}
        >
          {splitButton && (
            <div style={{ zIndex: 1 }}>
              <TimeRemainingText
                style={themeContext.NavigationBar.DealTimerText}
                until={limitedTimeOffer?.OFFER_END_TIME}
              />
            </div>
          )}
        </Button>
      </ImageBW>
    </MiddleSectionContainer>
  );
}

// 0 (NoSale) and no splited button ss
const noSaleBuyButtonAsset = assetSource(ASSET_KEY.IAP_WHOLE);
// 1 (Sale) and no splited button
const saleBuyButtonAsset = assetSource(ASSET_KEY.IAP_WHOLE_SALE);
// 2 (NoSaleDeal)
const noSaleDealLeftSideButtonAsset = assetSource(ASSET_KEY.IAP_SPLIT_GREEN);
// 3 (SaleDeal)
const saleDealLeftSideButtonAsset = assetSource(ASSET_KEY.IAP_SPLIT_SALE);
const saleDealRightSideButtonAsset = assetSource(ASSET_KEY.IAP_SPLIT_PINK);

export default MiddleSeciton;

const Styles = {
  ButtonContainserStyles: {
    flex: 1,
    justifyContent: 'center',
    pointerEvents: 'all',
    cursor: 'pointer',
    height: '100%',
    alignItems: 'center',
  },
  ButtonImageStyles: {
    height: '100%',
    pointerEvents: 'all',
    cursor: 'pointer',
    width: '100%',
  },
  RightSplitButtonContainerStyle: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'flex-start',
    pointerEvents: 'all',
    cursor: 'pointer',
  },
  RightSplitButtonImageStyle: {
    flex: 1,
    height: '100%',
    pointerEvents: 'all',
    cursor: 'pointer',
  },
  ButtonWrapperStyle: {
    position: 'absolute',
    left: 0,
    top: 0,
    height: '6rem',
    width: '100%',
  },
  ButtonWrapperInnerStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
};

const DefaultMiddleSection = styled.div`
  position: relative;
  font-weight: 700;
  width: ${pwaStyleAdapter(344, 'px', 1.25)};
`;

const MiddleSectionContainer = generateRender({
  default: DefaultMiddleSection,
});

